import React, { useState } from 'react'
import { LibraryBooks } from '@mui/icons-material'
import { Box, Button, Modal, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    maxWidth: '95%',
    bgcolor: 'var(--primary-bg)',
    border: '2px solid var(--primary-border)',
    boxShadow: 24,
    padding: '1rem',
    borderRadius: '8px'
}

const RewardRulesModal = () => {

    const [isOpen, setIsOpen] = useState(false)

  return (
    <>
        <Button disableRipple onClick={() => setIsOpen(true)} sx={{ fontWeight: 'bold', gap: '.5rem' }}>
            <LibraryBooks /> Rules
        </Button>
        <Modal open={isOpen} onClose={() => setIsOpen(false)}>
            <Box display="flex" flexDirection="column" sx={{ ...style }}>
                <Typography variant="h5" sx={{ mb: '3rem' }}>Reward Rules</Typography>

                <Box display="flex" flexDirection="column" gap=".25rem">
                    <Typography sx={{ fontWeight: 'bold', fontSize: '1.2em' }}>Get Started</Typography>
                    <ul>
                        <Typography component="li">All wager has to be done on Stake under code DDK/ZZZ or any other related codes.</Typography>
                        <Typography component="li">Wagering on house games is allowed.</Typography>
                        <Typography component="li">All wager is counted from 01/07/2025, previous wager does not count.</Typography>
                    </ul>
                </Box>

                <Box display="flex" flexDirection="column" sx={{ mt: '1rem' }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '1.2em' }}>Rewards</Typography>
                    <ul>
                        <Typography component="li">You can claim <b>all</b> rewards if you meet the wager requirement.</Typography>
                        <Typography component="li">You are able to claim each reward <b>once</b>.</Typography>
                        <Typography component="li">Rewards will be tipped to the stake account that completed the wager requirement.</Typography>
                    </ul>
                </Box>

                <Box display="flex" flexDirection="column" sx={{ mt: '1rem' }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '1.2em' }}>Wager</Typography>
                    <ul>
                        <Typography component="li">Games with RTP of 98% or lower → 100% of wagered amount will count</Typography>
                        <Typography component="li">Games with RTP above 98% → 50% of wagered amount will count</Typography>
                        <Typography component="li">Games with RTP of 99% or higher → 10% of wagered amount will count</Typography>
                        <Typography component="li">Abusers will be removed from the leaderboard and have their prize forfeited.</Typography>
                    </ul>
                </Box>

                <Typography sx={{ mt: '1rem' }}>If you meet the wager requirement for a reward make sure to claim it!</Typography>

            </Box>
        </Modal>
    </>
  )
}

export default RewardRulesModal